import React from 'react';
import PropTypes from 'prop-types';
import { styled as muiStyled } from '@mui/material/styles';
import Typography from '@digital-hig/mui/dist/Typography';
import SvgIcon from '@mui/material/SvgIcon';

const NumberedCircle = ({
  number,
  isCompleted = false,
  className = '',
  sx = {},
}) => (
  <StyledCircleContainer
    isCompleted={isCompleted}
    className={`circle-container ${className}`}
    data-completed={isCompleted}
    sx={sx}
  >
    {isCompleted ? (
      <SvgIcon className="checkmark-icon">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      </SvgIcon>
    ) : (
      <Typography variant="body-large" component="span">
        {number}
      </Typography>
    )}
  </StyledCircleContainer>
);

const StyledCircleContainer = muiStyled('div')(({ isCompleted }) => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  border: '2px solid #000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: isCompleted ? '#000' : '#fff',
  color: isCompleted ? '#fff' : '#000',
  flexShrink: 0,

  '& .checkmark-icon': {
    width: 20,
    height: 20,
    color: '#fff',
  },
}));

NumberedCircle.propTypes = {
  number: PropTypes.number.isRequired,
  isCompleted: PropTypes.bool,
  className: PropTypes.string,
  sx: PropTypes.shape({}),
};

NumberedCircle.defaultProps = {
  isCompleted: false,
  className: '',
  sx: {},
};

export default NumberedCircle;
